import React from 'react';
import { PageHeader } from '@/ui/PageHeader';
import { NotesBoard, type NotesBoardMetaField } from '@/components/NotesBoard';

const STATUS_OPTIONS = ['not_contacted', 'contacted', 'responded', 'negotiating', 'partnered', 'declined'];

const META_FIELDS: NotesBoardMetaField[] = [
  { key: 'handle', label: 'Handle', placeholder: '@handle' },
  { key: 'platform', label: 'Platform', placeholder: 'instagram / tiktok / twitter' },
];

export function InfluencerOutreachScreen() {
  return (
    <div className="admin-page max-w-3xl mx-auto">
      <PageHeader
        title="Influencer Outreach"
        subtitle="Lightweight CRM for creator relationships — handle, platform, and status through partnership."
      />
      <NotesBoard
        page="influencer_outreach"
        statusOptions={STATUS_OPTIONS}
        metadataFields={META_FIELDS}
        newButtonLabel="Add contact"
        emptyTitle="No outreach tracked yet"
        emptyHint="Add the first creator you're reaching out to above."
      />
    </div>
  );
}
